import { useQuery } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';
import { normalizarTicket } from '../mappers';

// Detalle de un ticket (GET /tickets/:id). Incluye estado/grupo/tema/agente
// resueltos y etiquetas: [{ id, nombre }]. Normalizamos estado/agente al id
// (el backend los devuelve como descripcion/nombre) para que los <select> de
// propiedades, EstadoBadge y el SLA los interpreten bien.
const useTicketDetalle = (headquarter, id) =>
  useQuery({
    queryKey: ticketsKeys.detalle(headquarter, id),
    queryFn: async () => normalizarTicket(await ticketsService.obtenerTicket({ headquarter, id })),
    enabled: Boolean(headquarter && id),
  });

export default useTicketDetalle;
